import React, { useEffect, useRef } from "react";

/**
 * Renders arbitrary HTML (including <script> tags) safely.
 * React's dangerouslySetInnerHTML does NOT execute injected scripts — the
 * browser ignores them when set via innerHTML. This component walks the
 * injected DOM and replaces each <script> with a fresh script element so
 * external embeds (123formbuilder, Typeform, etc.) actually run.
 */
export default function EmbedHtml({ html, className, ...rest }) {
  const ref = useRef(null);

  useEffect(() => {
    const host = ref.current;
    if (!host) return;
    host.innerHTML = "";
    if (!html || !html.trim()) return;

    const tpl = document.createElement("template");
    tpl.innerHTML = html;
    host.appendChild(tpl.content.cloneNode(true));

    // Re-create any <script> elements so the browser executes them
    const scripts = host.querySelectorAll("script");
    scripts.forEach((old) => {
      const s = document.createElement("script");
      for (const { name, value } of Array.from(old.attributes)) {
        s.setAttribute(name, value);
      }
      if (old.textContent) s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });

    return () => { if (host) host.innerHTML = ""; };
  }, [html]);

  return <div ref={ref} className={className} {...rest} />;
}
